import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './ui/estilos.css';
import App from './App';
import { iniciarAutoActualizacion } from './autoupdate';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Recarga sola cuando hay una versión nueva desplegada (el index.html se queda en caché)
iniciarAutoActualizacion();
